import onlineManagement from './onlineManagement'
import competitionRankData from './competitionRankData'
import sportsMeet from './sportsMeet'

export default {
  onlineManagement,
  competitionRankData,
  sportsMeet
}
